'use client';

/**
 * Chat suggested messages component
 * Shows suggested messages when chat is empty
 */

import React, { memo } from 'react';
import { CHAT_LAYOUT, BORDERS, INTERACTIVE } from '../../styles/chat-layout';

interface ChatSuggestedMessagesProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

function ChatSuggestedMessagesComponent({
  suggestions,
  onSuggestionClick,
}: ChatSuggestedMessagesProps) {
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className={`${BORDERS.divider} bg-background flex-shrink-0`}>
      <div className={CHAT_LAYOUT.inputWrapper}>
        <p className="text-sm text-muted-foreground mb-3">Suggestions:</p>
        <div className="flex flex-wrap gap-2">
          {suggestions.map((suggestion, i) => (
            <button
              key={i}
              onClick={() => onSuggestionClick(suggestion)}
              className={`px-3 py-1 text-sm bg-card ${BORDERS.card} rounded ${INTERACTIVE.hover} ${INTERACTIVE.transition}`}
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export const ChatSuggestedMessages = memo(ChatSuggestedMessagesComponent);
